import React, { createContext, useContext } from 'react'
import { connect } from 'react-redux'
import { object, string, func, array, node } from 'prop-types'

import { getDefaultCategoriesFiltersOptions } from '@/utils/products'
import useList from '@/hooks/useList'

const EnhancedListContext = createContext({})

const defaultCategoriesFiltersOptions = getDefaultCategoriesFiltersOptions()

const EnhancedListProvider = ({
  allItems = [],
  defaultFilters,
  defaultFiltersOptions = defaultCategoriesFiltersOptions,
  defaultSortValue,
  defaultSortOptions,
  supportedFilters = [],
  section,
  children,
}) => {
  const listProps = useList({
    allItems,
    defaultFilters,
    defaultFiltersOptions,
    defaultSortValue,
    defaultSortOptions,
    supportedFilters,
    section,
  })

  return (
    <EnhancedListContext.Provider value={{ ...listProps }}>
      {children}
    </EnhancedListContext.Provider>
  )
}

export const useEnhancedList = () => {
  const context = useContext(EnhancedListContext)

  if (context === undefined) {
    throw new Error(
      'useEnhancedList must be used within a EnhancedListProvider'
    )
  }

  return context
}

const mapStateToProps = (state, ownProps) => {
  const { items, itemsFilter } = ownProps
  const allItems = itemsFilter ? itemsFilter(items, state) : items

  return {
    allItems,
  }
}

EnhancedListProvider.propTypes = {
  items: array,
  allItems: array,
  defaultFilters: object,
  defaultSortValue: string,
  itemsFilter: func,
  children: node,
  defaultSortOptions: array,
  defaultFiltersOptions: object,
  supportedFilters: array,
  section: string,
}

export default connect(mapStateToProps)(EnhancedListProvider)
